module.exports = __webpack_public_path__ + "img/graduation.47900102.jpg";